/* global CookieControl, document */


// eslint-disable-next-line require-jsdoc, prefer-rest-params, brace-style
function gtag() {dataLayer.push(arguments);};

/**
 * Function to load and configure the Civic cookie tool
 */

const tagManagerSetup = function() {
  (function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      'event': 'gtm.js',
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-TPHN688');
};

const analyticsStatement = 'Analytics cookies collect information in an ' +
  'anonymous form and help us understand how you use our website, like ' +
  'which pages you visit and how long you stay on them. We use this ' +
  'information to compile reports and help us improve the website and your ' +
  'browsing experience.\n\n' +
  'Marketing cookies track your interests across different websites and show ' +
  'you ads that are more relevant to you. This means you\'ll see ads for ' +
  'products and services you\'re likely to be interested in, both on our ' +
  'website and on other websites. \n\n' +
  'You can learn more about how we use cookies and manage your preferences ' +
  'any time on our Privacy and Cookies page.';

const notifyDescription = 'We use cookies on our website to allow us to ' +
    'continuously improve our site and enhance your experience. You can use ' +
    'this tool to easily manage your cookie preferences, otherwise please ' +
    'click Accept Recommended Settings to let us know you’re happy for us to ' +
    'continue';

const intro = 'Some of these cookies are essential, while others help us to ' +
    'improve your experience by providing insights into how the site is' +
    'being used. By clicking Accept Recommended Settings' +
    'you are consenting to the use of cookies while you\'re on our website';

const necessaryDescription = 'Necessary cookies enable core functionality ' +
    'such as page navigation. The website cannot function properly without ' +
    'these cookies, and can only be disabled by changing your browser ' +
    'preferences.';

const thirdPartyDescription = 'Consent for the following cookies could not ' +
    'be automatically revoked. Please follow the link below to opt out ' +
    'manually.';

const config = {
  apiKey: '9728c8367e6e58d9ad9ce9126ed3355fc73aa45f',
  product: 'PRO_MULTISITE',

  necessaryCookies: [
    'has_js',
    'BIGipServerLTE-WS-04-Pool',
    'banner_dismissed',
    'csrftoken',
    'sessionid',
    'django_language',
  ],

  statement: {
    description: 'You can always change your mind. For more information, please see our',
    name: 'Privacy and Cookies page',
    url: '/legal/dataprotection/',
    updated: '16/02/2024',
  },
  optionalCookies: [{
    name: 'analytics',
    label: 'Analytics / Personalised Ads',
    description: analyticsStatement,
    cookies: ['CONSENT', 'NID', 'SAPISID', 'SSID', '1P_JAR',
      '_ga', '_gat', '_gid', '_gcl_au',
      'UULE', 'DV', 'IDE',
      '__utmx', '__utmxx',
      '_ceg.s', '_ceg.u', 'cean',
    ],
    onAccept: function() {
      tagManagerSetup();
      gtag('consent', 'update', {
        'ad_storage': 'granted', // advertising
        'ad_user_data': 'granted', // advertising
        'ad_personalization': 'granted', // remarketing
        'analytics_storage': 'granted', // analytics
      });
    },
    onRevoke: function() {
      gtag('consent', 'update', {
        'ad_storage': 'denied', // advertising
        'ad_user_data': 'denied', // advertising
        'ad_personalization': 'denied', // remarketing
        'analytics_storage': 'denied', // analytics
      });
    },

    thirdPartyCookies: [{
      name: 'Double click',
      optOutLink: 'https://ico.org.uk/your-data-matters/online/cookies/',
    }],
    recommendedState: true,
  }],

  initialState: 'notify',
  layout: 'popup',
  theme: 'DARK',
  position: 'right',

  text: {
    accept: 'Accept Recommended Settings',
    settings: 'Preferences',
    notifyDescription: notifyDescription,
    intro: intro,
    necessaryDescription: necessaryDescription,
    thirdPartyDescription: thirdPartyDescription,
  },

  branding: {
    fontFamily: 'Montserrat, sans-serif',
    fontColor: '#fff',
    fontSizeTitle: '1.3em',
    fontSizeIntro: '1.1em',
    fontSizeHeaders: '1.1em',
    fontSize: '0.9em',
    acceptText: '#fff',
    acceptBackground: '#9b5c8f',

    backgroundColor: '#3c3c3b',
    toggleText: '#fff',
    toggleColor: '#3c3c3b',
    toggleBackground: '#6aa130',
    buttonIcon: null,
    buttonIconWidth: '64px',
    buttonIconHeight: '64px',
    removeIcon: true,
    removeAbout: true,
  },
};

/**
 * Main function to instantiate the civic cookie tool
 */
export default function civicCookie() {
  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];

  // Set default consent to 'denied'
  gtag('consent', 'default', {
    'ad_storage': 'denied', // advertising
    'ad_user_data': 'denied', // advertising
    'ad_personalization': 'denied', // remarketing
    'analytics_storage': 'denied', // analytics
  });

  const cookieScript = document.createElement('script');
  cookieScript.src = 'https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js';
  cookieScript.onload = function() {
    CookieControl.load(config);

    const items = document.querySelectorAll('.cookie-preferences-trigger');

    items.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        CookieControl.open();
      });
    });
  };
  document.body.appendChild(cookieScript);
};
